import { useState } from "react";
import { Customer } from "../../Store/interfaces";

const CustomerTable: React.FC<{
  customers: Customer[];
  onRowSelect: (rowData: Customer, isChecked: boolean) => void;
}> = ({ customers, onRowSelect }) => {
  const [isSelected, setIsSelected] = useState(-1);

  const changeColor = (id: number) => {
    setIsSelected(id);
  };

  const rowClickHandler = (customer: Customer, index: number) => {
    changeColor(index);
    onRowSelect(customer, true);
  };

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-blue_navy text-white text-xs sm:text-sm md:text-base">
            <th className="p-2 border border-gray-300">Kundennr.</th>
            <th className="p-2 border border-gray-300">Kunde</th>
            <th className="p-2 border border-gray-300">E-Mailadressen</th>
            <th className="p-2 border border-gray-300 hidden sm:table-cell">
              Straße
            </th>
            <th className="p-2 border border-gray-300 hidden sm:table-cell">
              PLZ
            </th>
            <th className="p-2 border border-gray-300">Ort</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer: Customer, index: number) => (
            <tr
              key={index}
              onClick={() => rowClickHandler(customer, index)}
              className={`cursor-pointer text-xs sm:text-sm md:text-base ${
                isSelected === index ? "bg-gray-400" : "bg-gray-100"
              } hover:bg-gray-200`}
            >
              <td className="p-2 border border-gray-300 font-bold">
                {customer.Kundennummer}
              </td>
              <td className="p-2 border border-gray-300">{customer.Kunde}</td>
              <td className="p-2 border border-gray-300">
                {customer.email.length}
              </td>
              <td className="p-2 border border-gray-300 hidden sm:table-cell">
                {customer.Straße}
              </td>
              <td className="p-2 border border-gray-300 hidden sm:table-cell">
                {customer.plz}
              </td>
              <td className="p-2 border border-gray-300">{customer.Ort}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerTable;
